import { useQuery } from "@tanstack/react-query";
import { getClientDetail, searchClients } from "./api";

export const useClientSearch = (q: string) =>
  useQuery({
    queryKey: ["clients", "search", q],
    queryFn: () => searchClients(q),
    enabled: q.trim().length > 0,
  });

export const useClientDetail = (id: string | null) =>
  useQuery({
    queryKey: ["clients", "detail", id],
    queryFn: () => getClientDetail(id as string),
    enabled: !!id,
  });
